import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faRightFromBracket,
    faFileCirclePlus,
    faFilePen,
    faUserGear,
    faUserPlus
} from "@fortawesome/free-solid-svg-icons"
import { useNavigate, Link, useLocation } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import { apiSlice } from '../app/api/apiSlice'

import { useSendLogoutMutation } from '../features/auth/authApiSlice'
import useAuth from '../hooks/useAuth'

const DASH_REGEX = /^\/dash(\/)?$/
const NOTES_REGEX = /^\/dash\/notes(\/)?$/
const USERS_REGEX = /^\/dash\/users(\/)?$/

const DashHeader = () => {
    const {username, isManager, isAdmin} = useAuth()

    const navigate = useNavigate()
    const { pathname } = useLocation()
    const dispatch = useDispatch()

    const [sendLogout, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useSendLogoutMutation()

    useEffect(() => {
        if (isSuccess) {
          return (navigate('/') , console.log('navigated'))
        }
    }, [isSuccess, navigate])
    
    const onNewNoteClicked = () => navigate('/dash/notes/new')
    const onNewUserClicked = () => navigate('/dash/users/new')
    const onNotesClicked = () => navigate('/dash/notes')
    const onUsersClicked = () => navigate('/dash/users')

    // if (isLoading) return <p>Logging Out...</p>

    // if (isError) return <p>Error: {error.data?.message}</p>
    // The above commented code is removed as we have added them in the content itself

    let dashClass = null
    if (!DASH_REGEX.test(pathname) && !NOTES_REGEX.test(pathname) && !USERS_REGEX.test(pathname)) {
        dashClass = "dash-header__container--small"
    }

    let newNoteButton = null
    if(NOTES_REGEX.test(pathname)){ //means if we are in the notes path then show the add new note button
        newNoteButton = (
            <button
                className='icon-button'
                title='New Note'
                onClick={onNewNoteClicked}
            >
                <FontAwesomeIcon icon={faFileCirclePlus}/>
            </button>
        )
    }

    let newUserButton = null
    if(USERS_REGEX.test(pathname)){
        newUserButton = (
            <button
                className='icon-button'
                title='New User'
                onClick={onNewUserClicked}
            >
                <FontAwesomeIcon icon={faUserPlus}/>
            </button>
        )
    }

    let userButton = null
    if(isAdmin || isManager){
        if(!USERS_REGEX.test(pathname) && pathname.includes('/dash')) {
            userButton = (
                <button
                    className='icon-button'
                    title='Users'
                    onClick={onUsersClicked}
                >
                    <FontAwesomeIcon icon={faUserGear}/>
                </button>
            )
        }
    }

    let notesButton = null
    if(!NOTES_REGEX.test(pathname) && pathname.includes('/dash')) {
        notesButton = (
            <button
                className='icon-button'
                title='Notes'
                onClick={onNotesClicked}
            >
                <FontAwesomeIcon icon={faFilePen}/>
            </button>
        )
    }


    const onLogoutClicked = async () =>{
      try{
        await sendLogout()
        // if we dont set this settimeout then we will have one of our subscribtion from getusers or getnotes that is still active
        setTimeout(()=>{
            dispatch(apiSlice.util.resetApiState())
        },1000)
        // dispatch(apiSlice.util.resetApiState())
      } catch(error){
        console.log(error);
      }
    }

    const logoutButton = (
        <button
            className="icon-button"
            title="Logout"
            onClick={onLogoutClicked}
        >
            <FontAwesomeIcon icon={faRightFromBracket} />
        </button>
    )

    const errClass = isError ? "errmsg" : "offscreen"

    let buttonContent = null
    if(isLoading){
       buttonContent = <p>Loading...</p>
    }else{
        buttonContent = (
            <>
                {/* {username ? (newNoteButton,newUserButton,notesButton,userButton) :logoutButton } */}
                {newNoteButton}
                {newUserButton}
                {notesButton}
                {userButton}
                {logoutButton}
            </>
        )
    }

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>
            <header className="dash-header">
                <div className={`dash-header__container ${dashClass}`}>
                    <Link to="/dash">
                        <h1 className="dash-header__title">techNotes</h1>
                    </Link>
                    <nav className="dash-header__nav">
                        {/* add more buttons later */}
                        {/* {logoutButton} */}
                        {username ? buttonContent : logoutButton}
                        {/* { buttonContent} */}
                    </nav>
                </div>
            </header>
        </>
    )

    return content
}
export default DashHeader